import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { DrawingTypeResponse } from "../../../Controllers/Types/Project/ProjectResponse";
import { baseURL } from "../../ApiConstant";


// export const drawingTypeGetDataAPI = async (): Promise<DrawingTypeResponse> => {
//     try {
//         const token = localStorage.getItem('token');
//         const FULL_TOKEN = `Bearer ${token}`;

//         const response = await fetch(`${baseURL}/api/drawing-type`, {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json',
//                 'Authorization': FULL_TOKEN
//             },
//         });

//         const data = await response.json();

//         if (response.status === 200) {
//             return { status: true, statusCode: 200, data: data['data'] };
//         } else if (response.status === 401) {
//             return { status: false, statusCode: 401, massage: "Unauthorized" };
//         } else if (response.status === 422) {
//             return { status: false, statusCode: 422, massage: "Body error" };
//         } else if (response.status === 404) {
//             return { status: false, statusCode: 404, massage: "Not found" };
//         } else {
//             return { status: false, statusCode: 500, massage: "Error" };
//         }

//     } catch (error) {
//         throw error;
//     }
// };

export const drawingTypeListDataAPI = async (data_for: string, user_id: number | null, folder_id: number | null, sub_folder_id: number | null): Promise<DrawingTypeResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/drawing-type/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ data_for, user_id, folder_id, sub_folder_id}),
        });

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const drawingTypeCreateAPI = async (type: string): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/drawing-type/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ type}),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error", errors: data['errors'] };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};